import type { FaireProductEntity } from "../../entity_types/product";

export const p_75tarzvan4: FaireProductEntity = {
  token: "p_75tarzvan4",
  type: "product",
  name: "Blue Bandana Fringe Crossbody",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/0d0af0a73f5aec97cfcd84c2284c59dd4fb9d304f6c2964eedf88d74b3a85d45.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/496023585c3f7e6df490efc6579136d4eb775a44f1fd77cbef13ac4d30dd2768.jpeg",
    "https://cdn.faire.com/fastly/024c0e65e77e60a133a8848aa520f0dc31b4513ebdb6bad9a5195398d6951c8b.jpeg"
  ],
  priceDollars: 37.95,
  description: "A blue bandana fringe crossbody featuring a classic paisley print, designed with a long crossbody strap and suede leather fringe detailing for a stylish western-inspired look. Roomy interior is perfect for carrying daily essentials while adding a statement touch to any outfit.\n\n14\" W x 10\" H\n\n100% Cotton\n\nMin. Qty: 2",
  tags: [],
  msrpDollars: 94.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:43.827Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
